import React, { useId, useState } from "react";
import styles from "../styles/UnknownBirthTimeCheckbox.module.css";

/**
 * "Don't know my exact time of birth" checkbox + accuracy note.
 * Sits under the Date of Birth field; the parent decides what checking it does
 * (the landing pages set the birth time to 12:00 PM).
 *
 * Checking it requires confirmation via a modal (unchecking does not, since
 * that's just reverting to entering the real time). This stays local to the
 * component so both LandingPage and LandingPageVariantB get it for free.
 */
const UnknownBirthTimeCheckbox = ({
  checked,
  onChange,
  label = "Don't know my exact time of birth",
  note = "Note: Without time of birth, we can still achieve upto 80% accurate predictions",
  confirmTitle = "Are you sure you don't know your time of birth?",
  confirmMessage = "Without time of birth, we can still achieve upto 80% accurate predictions",
  confirmYesLabel = "Yes",
  confirmCancelLabel = "Cancel",
}) => {
  const noteId = useId();
  const [showConfirm, setShowConfirm] = useState(false);

  const handleCheckboxChange = (e) => {
    if (e.target.checked) {
      setShowConfirm(true);
    } else {
      onChange(false);
    }
  };

  const handleConfirm = () => {
    setShowConfirm(false);
    onChange(true);
  };

  const handleCancel = () => {
    setShowConfirm(false);
  };

  return (
    <div className={styles.wrapper}>
      <label className={styles.label}>
        <input
          type="checkbox"
          className={styles.checkbox}
          checked={checked}
          onChange={handleCheckboxChange}
          aria-describedby={noteId}
        />
        <span>{label}</span>
      </label>
      <p id={noteId} className={styles.note}>
        {note}
      </p>

      {showConfirm && (
        <div className={styles.modalOverlay} onClick={handleCancel}>
          <div
            className={styles.modalContent}
            role="dialog"
            aria-modal="true"
            aria-labelledby="unknown-tob-confirm-title"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 id="unknown-tob-confirm-title" className={styles.modalTitle}>
              {confirmTitle}
            </h3>
            {confirmMessage && (
              <p className={styles.modalMessage}>{confirmMessage}</p>
            )}
            <div className={styles.modalActions}>
              <button
                type="button"
                className={styles.cancelBtn}
                onClick={handleCancel}
              >
                {confirmCancelLabel}
              </button>
              <button
                type="button"
                className={styles.confirmBtn}
                onClick={handleConfirm}
              >
                {confirmYesLabel}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UnknownBirthTimeCheckbox;
